// src/store/mapConfigSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chartType: null,
  colorIndicator: null,
  patternIndicator: null,
  indicators: [],           // Bubble / Marker / Pie chart indicators
  selectedLocations: [],
  Locations: [],
  colorSubIndicator: null,
  patternSubIndicator: null,
  fullIndicatorInfo: {},    // indicator_info

  barConfig: {
    selectedLocations: [],
    indicators: [],
    barChartType: "column",
  },
  
  pieConfig: {
    selectedLocations: [],
    indicators: [],
    pieChartType: "pie",
  },
  
  stackedConfig: {
    selectedLocations: [],
    indicators: [],
    stackedChartType: "column",
  },
  
  tableConfig: {
    selectedLocations: [],
    indicators: [],
  },
};

const mapConfigSlice = createSlice({
  name: "mapConfig",
  initialState,
  reducers: {
    setMapConfig: (state, action) => {
      const {
        chartType,
        colorIndicator,
        colorSubIndicator,
        patternIndicator,
        patternSubIndicator,
        indicators,
        Locations,
        selectedLocations,
        indicator_info,
      } = action.payload;

      state.chartType = chartType;
      state.colorIndicator = colorIndicator;
      state.patternIndicator = patternIndicator;
      state.colorSubIndicator = colorSubIndicator;
      state.patternSubIndicator = patternSubIndicator;
      state.indicators = indicators;
      state.selectedLocations = selectedLocations;
      state.Locations = Locations;
      state.fullIndicatorInfo = indicator_info || {};
    },
    resetMapConfig: (state) => {
      return initialState;
    },
    resetAllConfigs: (state) => {
      // Reset all configuration states
      state.chartType = null;
      state.colorIndicator = null;
      state.patternIndicator = null;
      state.indicators = [];
      state.selectedLocations = [];
      state.Locations = [];
      state.fullIndicatorInfo = {};
      state.barConfig = {
        selectedLocations: [],
        indicators: [],
        barChartType: "column",
      };
      state.pieConfig = {
        selectedLocations: [],
        indicators: [],
        pieChartType: "pie",
      };
      state.stackedConfig = {
        selectedLocations: [],
        indicators: [],
        stackedChartType: "column",
      };
      state.tableConfig = {
        selectedLocations: [],
        indicators: [],
      };
    },
 setBarConfig: (state, action) => {
      const { indicators, selectedLocations, barChartType } = action.payload;
      state.barConfig = {
        barChartType: barChartType || "column",
        indicators: indicators || [],
        selectedLocations: selectedLocations || [],
      };
    },
  setPieConfig:(state,action)=>{
    const { indicators, selectedLocations, pieChartType } = action.payload;
      state.pieConfig = {
        pieChartType: pieChartType || "pie",
        indicators: indicators || [],
        selectedLocations: selectedLocations || [],
      };
  },
setStackedConfig:(state,action)=>{
    const { indicators, selectedLocations, stackedChartType } = action.payload;
      state.stackedConfig = {
        stackedChartType: stackedChartType || "column",
        indicators: indicators || [],
        selectedLocations: selectedLocations || [],
      };
  },
  setTableConfig:(state,action)=>{
    const { indicators, selectedLocations } = action.payload;
      state.tableConfig = {
        indicators: indicators || [],
        selectedLocations: selectedLocations || [],
      };
  }
  },
});

export const { setMapConfig, resetMapConfig,setBarConfig ,resetAllConfigs,setPieConfig,setStackedConfig,setTableConfig} = mapConfigSlice.actions;
export default mapConfigSlice.reducer;
